"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _dialog = _interopRequireDefault(require("../../_common/dialog"));

var _index = _interopRequireDefault(require("./index"));

var _nicaLocatorCore = require("../../nicaLocatorCore");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FiltersDialog = function FiltersDialog(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose;

  var _useContext = (0, _react.useContext)(_nicaLocatorCore.AppContext),
      FiltersComponent = _useContext.components.FiltersComponent;

  var actions = /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-end"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "text",
    color: "primary",
    onClick: onClose
  }, "Done"));

  return /*#__PURE__*/_react.default.createElement(_dialog.default, {
    title: "Filters",
    open: open,
    onClose: onClose,
    actions: actions
  }, !FiltersComponent ? /*#__PURE__*/_react.default.createElement(_index.default, null) : /*#__PURE__*/_react.default.createElement(FiltersComponent, null));
};

var _default = FiltersDialog;
exports.default = _default;